import { z } from 'zod';
import { createToolSignature } from './tool-signature';
const LinkedinProfileResultSchema = z.object({
    profileMemberId: z.string(),
    profilePublicIdentifier: z.string(),
    profileSummary: z.string(),
});

export const getUserLinkedinProfileToolSignature = createToolSignature({
    name: 'getUserLinkedinProfileTool',
    description:
        "Get the professional (LinkedIn) profile of the current user. The profile includes the user's name, headline, location, number of connections, current and previous experiences, education, contact details.",
    inputSchema: z.object({}),
    outputSchema: LinkedinProfileResultSchema,
    toolCallUi: (input) => `Checking your Linkedin profile`,
});
